function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import TokenType from "./utils/types/tokenType.js";
import { TokenParserMode } from "./utils/types/stackElement.js"; // Parser States

var TokenParserState;

(function (TokenParserState) {
  TokenParserState[TokenParserState["VALUE"] = 0] = "VALUE";
  TokenParserState[TokenParserState["KEY"] = 1] = "KEY";
  TokenParserState[TokenParserState["COLON"] = 2] = "COLON";
  TokenParserState[TokenParserState["COMMA"] = 3] = "COMMA";
  TokenParserState[TokenParserState["ENDED"] = 4] = "ENDED";
  TokenParserState[TokenParserState["ERROR"] = 5] = "ERROR";
  TokenParserState[TokenParserState["SEPARATOR"] = 6] = "SEPARATOR";
})(TokenParserState || (TokenParserState = {}));

function TokenParserStateToString(state) {
  return ["VALUE", "KEY", "COLON", "COMMA", "ENDED", "ERROR", "SEPARATOR"][state];
}

var defaultOpts = {
  paths: undefined,
  keepStack: true,
  separator: undefined,
  emitPartialValues: false
};
export var TokenParserError = /*#__PURE__*/function (_Error) {
  _inherits(TokenParserError, _Error);

  var _super = _createSuper(TokenParserError);

  function TokenParserError(message) {
    var _this;

    _classCallCheck(this, TokenParserError);

    _this = _super.call(this, message); // Typescript is broken. This is a workaround

    Object.setPrototypeOf(_assertThisInitialized(_this), TokenParserError.prototype);
    return _this;
  }

  return TokenParserError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TokenParser = /*#__PURE__*/function () {
  function TokenParser(opts) {
    _classCallCheck(this, TokenParser);

    this.state = TokenParserState.VALUE;
    this.mode = undefined;
    this.key = undefined;
    this.value = undefined;
    this.stack = [];
    opts = Object.assign(Object.assign({}, defaultOpts), opts);

    if (opts.paths) {
      this.paths = opts.paths.map(function (path) {
        if (path === undefined || path === "$*") return undefined;
        if (!path.startsWith("$")) throw new TokenParserError("Invalid selector \"".concat(path, "\". Should start with \"$\"."));
        var pathParts = path.split(".").slice(1);
        if (pathParts.includes("")) throw new TokenParserError("Invalid selector \"".concat(path, "\". \"..\" syntax not supported."));
        return pathParts;
      });
    }

    this.keepStack = opts.keepStack || false;
    this.separator = opts.separator;

    if (!opts.emitPartialValues) {
      this.emitPartial = function () {};
    }
  }

  _createClass(TokenParser, [{
    key: "shouldEmit",
    value: function shouldEmit() {
      var _this2 = this;

      if (!this.paths) return true;
      return this.paths.some(function (path) {
        var _a;

        if (path === undefined) return true;
        if (path.length !== _this2.stack.length) return false;

        for (var i = 0; i < path.length - 1; i++) {
          var _selector = path[i];
          var key = _this2.stack[i + 1].key;
          if (_selector === "*") continue;
          if (_selector !== key) return false;
        }

        var selector = path[path.length - 1];
        if (selector === "*") return true;
        return selector === ((_a = _this2.key) === null || _a === void 0 ? void 0 : _a.toString());
      });
    }
  }, {
    key: "push",
    value: function push() {
      this.stack.push({
        key: this.key,
        value: this.value,
        mode: this.mode,
        emit: this.shouldEmit()
      });
    }
  }, {
    key: "pop",
    value: function pop() {
      var value = this.value;
      var emit;

      var _this$stack$pop = this.stack.pop();

      this.key = _this$stack$pop.key;
      this.value = _this$stack$pop.value;
      this.mode = _this$stack$pop.mode;
      emit = _this$stack$pop.emit;
      this.state = this.mode !== undefined ? TokenParserState.COMMA : TokenParserState.VALUE;
      this.emit(value, emit);
    }
  }, {
    key: "emit",
    value: function emit(value, _emit) {
      if (!this.keepStack && this.value && this.stack.every(function (item) {
        return !item.emit;
      })) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete this.value[this.key];
      }

      if (_emit) {
        this.onValue({
          value: value,
          key: this.key,
          parent: this.value,
          stack: this.stack
        });
      }

      if (this.stack.length === 0) {
        if (this.separator) {
          this.state = TokenParserState.SEPARATOR;
        } else if (this.separator === undefined) {
          this.end();
        } // else if separator === '', expect next JSON object.

      }
    }
  }, {
    key: "emitPartial",
    value: function emitPartial(value) {
      if (!this.shouldEmit()) return;

      if (this.state === TokenParserState.KEY) {
        this.onValue({
          value: undefined,
          key: value,
          parent: this.value,
          stack: this.stack,
          partial: true
        });
        return;
      }

      this.onValue({
        value: value,
        key: this.key,
        parent: this.value,
        stack: this.stack,
        partial: true
      });
    }
  }, {
    key: "isEnded",
    get: function get() {
      return this.state === TokenParserState.ENDED;
    }
  }, {
    key: "write",
    value: function write(_ref) {
      var token = _ref.token,
          value = _ref.value,
          partial = _ref.partial;

      try {
        if (partial) {
          this.emitPartial(value);
          return;
        }

        if (this.state === TokenParserState.VALUE) {
          if (token === TokenType.STRING || token === TokenType.NUMBER || token === TokenType.TRUE || token === TokenType.FALSE || token === TokenType.NULL) {
            if (this.mode === TokenParserMode.OBJECT) {
              this.value[this.key] = value;
              this.state = TokenParserState.COMMA;
            } else if (this.mode === TokenParserMode.ARRAY) {
              this.value.push(value);
              this.state = TokenParserState.COMMA;
            }

            this.emit(value, this.shouldEmit());
            return;
          }

          if (token === TokenType.LEFT_BRACE) {
            this.push();

            if (this.mode === TokenParserMode.OBJECT) {
              this.value = this.value[this.key] = {};
            } else if (this.mode === TokenParserMode.ARRAY) {
              var val = {};
              this.value.push(val);
              this.value = val;
            } else {
              this.value = {};
            }

            this.mode = TokenParserMode.OBJECT;
            this.state = TokenParserState.KEY;
            this.key = undefined;
            this.emitPartial();
            return;
          }

          if (token === TokenType.LEFT_BRACKET) {
            this.push();

            if (this.mode === TokenParserMode.OBJECT) {
              this.value = this.value[this.key] = [];
            } else if (this.mode === TokenParserMode.ARRAY) {
              var _val = [];
              this.value.push(_val);
              this.value = _val;
            } else {
              this.value = [];
            }

            this.mode = TokenParserMode.ARRAY;
            this.state = TokenParserState.VALUE;
            this.key = 0;
            this.emitPartial();
            return;
          }

          if (this.mode === TokenParserMode.ARRAY && token === TokenType.RIGHT_BRACKET && this.value.length === 0) {
            this.pop();
            return;
          }
        }

        if (this.state === TokenParserState.KEY) {
          if (token === TokenType.STRING) {
            this.key = value;
            this.state = TokenParserState.COLON;
            this.emitPartial();
            return;
          }

          if (token === TokenType.RIGHT_BRACE && Object.keys(this.value).length === 0) {
            this.pop();
            return;
          }
        }

        if (this.state === TokenParserState.COLON) {
          if (token === TokenType.COLON) {
            this.state = TokenParserState.VALUE;
            return;
          }
        }

        if (this.state === TokenParserState.COMMA) {
          if (token === TokenType.COMMA) {
            if (this.mode === TokenParserMode.ARRAY) {
              this.state = TokenParserState.VALUE;
              this.key += 1;
              return;
            }
            /* istanbul ignore else */


            if (this.mode === TokenParserMode.OBJECT) {
              this.state = TokenParserState.KEY;
              return;
            }
          }

          if (token === TokenType.RIGHT_BRACE && this.mode === TokenParserMode.OBJECT || token === TokenType.RIGHT_BRACKET && this.mode === TokenParserMode.ARRAY) {
            this.pop();
            return;
          }
        }

        if (this.state === TokenParserState.SEPARATOR) {
          if (token === TokenType.SEPARATOR && value === this.separator) {
            this.state = TokenParserState.VALUE;
            return;
          }
        }

        throw new TokenParserError("Unexpected ".concat(TokenType[token], " (").concat(JSON.stringify(value), ") in state ").concat(TokenParserStateToString(this.state))); // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err) {
        this.error(err);
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      if (this.state !== TokenParserState.ENDED) {
        this.state = TokenParserState.ERROR;
      }

      this.onError(err);
    }
  }, {
    key: "end",
    value: function end() {
      if (this.state !== TokenParserState.VALUE && this.state !== TokenParserState.SEPARATOR || this.stack.length > 0) {
        this.error(new Error("Parser ended in mid-parsing (state: ".concat(TokenParserStateToString(this.state), "). Either not all the data was received or the data was invalid.")));
      } else {
        this.state = TokenParserState.ENDED;
        this.onEnd();
      }
    }
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */

  }, {
    key: "onValue",
    value: function onValue(parsedElementInfo) {
      // Override me
      throw new TokenParserError('Can\'t emit data before the "onValue" callback has been set up.');
    }
  }, {
    key: "onError",
    value: function onError(err) {
      // Override me
      throw err;
    }
  }, {
    key: "onEnd",
    value: function onEnd() {// Override me
    }
  }]);

  return TokenParser;
}();

export { TokenParser as default };